import React from 'react';
import clx from 'classnames';
import { Layout, Row, Col, Space, Breadcrumb } from 'antd';
const { Header, Content, Footer, Sider } = Layout;
import './HeaderAdmin.scss';
import { AdminMenu } from '../../routes/menu/AdminMenu';

export interface HeaderAdminProps {
  isLogin?: boolean;
}

/**
 * Intestazione dell'area amministrazione dell'applicativo.
 * Contiene il menu principale.
 */
export function HeaderAdmin(props: HeaderAdminProps) {
  return (
    <Header className={clx('header-admin')}>
      <Row
        justify="start"
        align="middle"
        className="header-logo-row"
        gutter={16}
      >
        <Col>
          <Space size="middle" align="center">
            <div className="logo-main"></div>
            <div className="logo-app"></div>
          </Space>
        </Col>
        <Col flex="auto">
          <div className="logo-stripe-bg">
            <div className="logo-institutional"></div>
          </div>
        </Col>
      </Row>
      {/* Nella pagina di login eliminiamo il menu */}
      {!props.isLogin && <AdminMenu />}
    </Header>
  );
}
